/* HEALIE® Recenze – „spotlight" citát na homepage.
   Jedna recenze v hlavní roli: velký patkový citát, který se střídá,
   vlevo souhrnné hodnocení. Klik na citát otevře celou recenzi. */
(function () {
  document.querySelectorAll(".br-carousel:not([data-br-init])").forEach(initCarousel);

  function initCarousel(root) {
    root.dataset.brInit = "1";
    var heading = root.dataset.heading || "Co říkají zákazníci";
    var limit = Number(root.dataset.limit) || 12;
    var autoplay = root.dataset.autoplay !== "false";

    function esc(s) {
      return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    function stars(n) {
      var out = "";
      for (var i = 1; i <= 5; i++) out += '<span class="' + (i <= n ? "" : "off") + '">★</span>';
      return '<span class="br-review-stars" aria-label="' + n + ' z 5">' + out + "</span>";
    }
    function plural(n) {
      if (n === 1) return "1 recenze";
      if (n >= 2 && n <= 4) return n + " recenze";
      return n + " recenzí";
    }
    function fmtDate(d) {
      try {
        return new Date(d).toLocaleDateString("cs-CZ", { year: "numeric", month: "long", day: "numeric" });
      } catch (e) { return ""; }
    }

    // modal s celou recenzí (stejný vzhled jako lightbox widgetu)
    var modalEl = null;
    function closeModal() {
      if (modalEl) { modalEl.remove(); modalEl = null; }
      document.removeEventListener("keydown", escModal);
    }
    function escModal(e) { if (e.key === "Escape") closeModal(); }
    function openModal(r) {
      closeModal();
      var media = (r.media || [])[0];
      var content = "";
      if (media && media.type === "photo") {
        content = '<img src="' + esc(media.url) + '" alt="Fotka od zákazníka">';
      } else if (media && media.type === "video") {
        content = '<video src="' + esc(media.url) + '"' + (media.thumb ? ' poster="' + esc(media.thumb) + '"' : "") + " controls playsinline></video>";
      }
      var productLink = r.productHandle
        ? '<a class="br-lightbox-panel-product" href="/products/' + esc(r.productHandle) + '#healie-recenze">' + esc(r.productTitle || "Zobrazit produkt") + " →</a>"
        : "";
      modalEl = document.createElement("div");
      modalEl.className = "br-lightbox";
      modalEl.innerHTML =
        '<button type="button" class="br-lightbox-close" aria-label="Zavřít">×</button>' +
        '<div class="br-lightbox-inner' + (content ? "" : " br-lightbox-inner--textonly") + '">' +
        (content ? '<div class="br-lightbox-media">' + content + "</div>" : "") +
        '<aside class="br-lightbox-panel">' +
        '<div class="br-lightbox-panel-head">' + stars(r.rating) +
        '<span class="br-review-name">' + esc(r.name) + "</span>" +
        (r.verified ? '<span class="br-verified">' + CHECK + " Ověřený nákup</span>" : "") + "</div>" +
        (r.date ? '<div class="br-lightbox-panel-date">' + fmtDate(r.date) + "</div>" : "") +
        (r.title ? '<div class="br-review-title">' + esc(r.title) + "</div>" : "") +
        (r.body ? '<div class="br-lightbox-panel-body">' + esc(r.body) + "</div>" : "") +
        productLink +
        "</aside></div>";
      document.body.appendChild(modalEl);
      var v = modalEl.querySelector("video");
      if (v) { v.muted = false; v.play().catch(function () {}); }
      modalEl.addEventListener("click", function (e) {
        if (e.target === modalEl || e.target.classList.contains("br-lightbox-close")) closeModal();
      });
      document.addEventListener("keydown", escModal);
    }

    function load() {
      if (root.dataset.brLoaded) return;
      root.dataset.brLoaded = "1";
      fetch("/apps/recenze/featured?limit=" + limit)
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () { root.style.display = "none"; });
    }

    function render(data) {
      if (!data.reviews || !data.reviews.length) { root.style.display = "none"; return; }
      var agg = data.aggregate;
      var recenze = data.reviews;
      var index = 0;

      var teckyHtml = recenze.map(function (_, i) {
        return '<button type="button" class="br-spot-tecka" data-i="' + i + '" aria-label="Recenze ' + (i + 1) + '"></button>';
      }).join("");

      root.innerHTML =
        '<div class="br-spot">' +
        '<div class="br-spot-souhrn">' +
        '<h2 class="br-heading">' + esc(heading) + "</h2>" +
        '<div class="br-spot-avg"><span class="br-spot-cislo">' + agg.avg.toLocaleString("cs-CZ", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + "</span>" + stars(Math.round(agg.avg)) + "</div>" +
        '<div class="br-spot-pocet">' + plural(agg.count) +
          (agg.verifiedCount ? ", z toho " + agg.verifiedCount + " s ověřeným nákupem" : "") + "</div>" +
        '<a class="br-carousel-all" href="/apps/recenze">Zobrazit všechny recenze →</a>' +
        (data.verificationText
          ? '<button type="button" class="br-verify-toggle">Jak ověřujeme recenze</button>' +
            '<div class="br-verify-text">' + esc(data.verificationText) + "</div>"
          : "") +
        "</div>" +
        '<div class="br-spot-scena">' +
        '<div class="br-spot-uvozovka" aria-hidden="true">&ldquo;</div>' +
        '<figure class="br-spot-obsah" role="button" tabindex="0" aria-label="Zobrazit celou recenzi">' +
        '<blockquote class="br-spot-text"></blockquote>' +
        '<figcaption class="br-spot-meta"></figcaption>' +
        "</figure>" +
        '<div class="br-spot-ovladani">' +
        '<button type="button" class="br-spot-sipka prev" aria-label="Předchozí recenze">‹</button>' +
        '<div class="br-spot-tecky">' + teckyHtml + "</div>" +
        '<button type="button" class="br-spot-sipka next" aria-label="Další recenze">›</button>' +
        "</div></div></div>";

      var obsah = root.querySelector(".br-spot-obsah");
      var textEl = root.querySelector(".br-spot-text");
      var metaEl = root.querySelector(".br-spot-meta");
      var tecky = root.querySelectorAll(".br-spot-tecka");

      function ukaz(i, bezAnimace) {
        index = (i + recenze.length) % recenze.length;
        var r = recenze[index];
        var photo = (r.media || []).find(function (m) { return m.type === "photo"; });
        var thumb = photo ? (photo.thumb || photo.url) : (r.media || []).find(function (m) { return m.type === "video" && m.thumb; });
        if (thumb && thumb.thumb) thumb = thumb.thumb;

        function napln() {
          textEl.textContent = r.title ? r.title + " — " + r.body : r.body;
          metaEl.innerHTML =
            (thumb ? '<img class="br-spot-foto" src="' + esc(thumb) + '" alt="Fotka od zákazníka" loading="lazy">' : "") +
            '<span class="br-spot-jmeno">' + esc(r.name) + "</span>" +
            (r.verified ? '<span class="br-verified">' + CHECK + " Ověřený nákup</span>" : "") +
            (r.productTitle ? '<span class="br-spot-produkt">' + esc(r.productTitle) + "</span>" : "");
        }
        if (bezAnimace) { napln(); }
        else {
          obsah.classList.add("mizi");
          setTimeout(function () {
            napln();
            obsah.classList.remove("mizi");
          }, 260);
        }
        tecky.forEach(function (t, ti) { t.classList.toggle("aktivni", ti === index); });
      }

      var verifyBtn = root.querySelector(".br-verify-toggle");
      if (verifyBtn) {
        verifyBtn.addEventListener("click", function () {
          root.querySelector(".br-verify-text").classList.toggle("open");
        });
      }

      root.querySelector(".br-spot-sipka.prev").addEventListener("click", function () { ukaz(index - 1); rucne(); });
      root.querySelector(".br-spot-sipka.next").addEventListener("click", function () { ukaz(index + 1); rucne(); });
      tecky.forEach(function (t) {
        t.addEventListener("click", function () { ukaz(Number(t.dataset.i)); rucne(); });
      });
      obsah.addEventListener("click", function () { openModal(recenze[index]); });
      obsah.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openModal(recenze[index]); }
      });

      var casovac = null;
      var pauza = false;
      function rucne() { pauza = true; setTimeout(function () { pauza = false; }, 12000); }
      if (autoplay && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        casovac = setInterval(function () {
          if (pauza || !document.contains(root)) return;
          ukaz(index + 1);
        }, 6000);
        ["mouseenter", "focusin", "touchstart"].forEach(function (ev) {
          root.addEventListener(ev, function () { pauza = true; }, { passive: true });
        });
        root.addEventListener("mouseleave", function () { pauza = false; });
      }

      ukaz(0, true);
    }

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          load();
        }
      }, { rootMargin: "500px" });
      io.observe(root);
      // pojistka: prázdný element nemusí observer spolehlivě protnout
      setTimeout(load, 2500);
    } else {
      load();
    }
  }
})();
